import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getMonths, getSubAccountRevShareByMonth, getYearsWithData } from "../../apis/revshare/ReportsApi";
import DataGridNew from "../common/DataGrids/DataGrid-new";
import { Accordion, Button, Card, Col, Form, Row, Tab, Tabs, Spinner } from "react-bootstrap";
import SelectInput from "../common/forms/SelectInput";
import FormRow from "../common/forms/FormRow";


export default function SubAccountsByMonthGrid(props) {
    
    const [allData, setAllData] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [months, setMonths] = useState([]);
    const [subAccountSelect, setSubAccountSelect] = useState([]);
    
    const headers = [
      {
          key: "subaccount",
          label: "Subaccount",
          columns: [
              { label: "Subaccount", key: "subAccount", isNumber: true },
          ]
      },
      {
          key: "dollars",
          label: "Dollars",
          columns: [
              { label: "Start Bal.", key: "startValue", isNumber: true },
              { label: "Earned", key: "valueEarned", isNumber: true },
              { label: "Used", key: "valueUsed", isNumber: true },
              { label: "End Bal.", key: "currentValue", isNumber: true },
              { label: "Net Diff.", key: "netValueDifference", isNumber: true },
          ]
      },
      {
          key: "hours",
          label: "Hours",
          columns: [
              { label: "Start Bal.", key: "startHours", isNumber: true },
              { label: "Earned", key: "hoursEarned", isNumber: true },
              { label: "Used", key: "hoursUsed", isNumber: true },
              { label: "End Bal", key: "currentHours", isNumber: true },
              { label: "Net Diff.", key: "netHoursDifference", isNumber: true },
          ]
      },
    ];

  const getYears = () => {
    let data = getYearsWithData();
    return data;
  }

  useEffect(() => {
    getMonths(props.year)
      .then((months) => setMonths(months))
      .catch((error) => {
        throw error;
      });

    getSubAccountRevShareByMonth(props.year, props.isManager)
      .then((data) => {
        setData(data);
        setLoading(false);
        setAllData(data);
      })
      .catch((error) => {
        throw error;
      });
  }, [props.year]);

  const filterGrid = () => {
    let filtered = allData;
    if (subAccountSelect.value !== "All") {
      filtered = filtered.filter((i) => i.subAccount === subAccountSelect.value);
    }
    setData(filtered);
  };

  return (
    <>
      <Row>
        <Col xs="12">
          <Accordion>
            <Card style={{ border: "none" }}>
              <Accordion.Toggle as={Button} variant="link" eventKey="0">
                Filter
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Form>
                  <FormRow
                    columns={[
                      <SelectInput
                        default="All"
                        label="Sub Account"
                        onChange={filterGrid}
                        options={data
                          .map((i) => i.subAccount)
                          .filter((v, i, a) => a.indexOf(v) === i)
                          .sort()}
                        ref={(element) => setSubAccountSelect(element)}
                      />,
                    ]}
                  />
                </Form>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Col>
      </Row>
      <Row>
        {loading ? <Spinner animation="border" /> : null}
        <Tabs justify variant="tabs">
          {months.map((month) => (
            <Tab eventKey={month.name} key={month.name} title={month.name}>
              <DataGridNew
                data={data.filter((i) => i.month.number === month.number)}
                exportName="SubaccountByMonthReport"
                headers={headers}
              />
            </Tab>
          ))}
        </Tabs>
      </Row>
    </>
  );
};

SubAccountsByMonthGrid.propTypes = {
  isManager: PropTypes.bool,
  year: PropTypes.number.isRequired,
};
